import React from 'react';
import Text from 'components/Core/Text';
import icon from './images/sign-in-icon.svg';
import HyperLink from 'components/Core/HyperLink';

import { Container } from './styles';

const AnnouncementBar = ({ copy, hideSignIn, linkTitle, linkUrl, theme }) => {
  const darkTheme = theme === 'lightHeroHeader';

  return (
    <Container darkTheme={darkTheme}>
      <Text type="p" size="normal">
        {copy || 'Discover your ROI with ServiceTitan'}
        {': '}
        <HyperLink href={linkUrl || '/tools/roi-calculator'} className="announcement-bar--link">
          {linkTitle || 'Calculate Here'}
        </HyperLink>
      </Text>
      {!hideSignIn && (
        <div className="announcement-bar--sign-in">
          <Text type="p" size="normal">
            <strong>
              <a href="https://go.servicetitan.com/Auth/Login" target="_blank">
                Sign in
              </a>
            </strong>
          </Text>
          <img src={icon} className="announcement-bar--icon" />
        </div>
      )}
    </Container>
  );
};

export default AnnouncementBar;
